import request from '@/config/tmhRequest'

export default {
    searchPerferenceInfo: function (data) {
        return request({
            url: '/customer/perferenceinfo/searchperferenceinfo',
            method: 'get',
            params: data
        })
    },
    searchPerferenceResult: function (data) {
        return request({
            url: '/customer/perferenceinfo/searchperferenceresult',
            method: 'get',
            params: data
        })
    },
    addPerferenceInfo: function (data) {
        return request({
            url: '/customer/tmh/perferenceinfo/addperferenceinfo',
            method: 'POST',
            data: data
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/customer/perferenceinfo.js